<template>
	<div id="app">
		<transition name="fade"
		            mode="out-in">
			<router-view v-if="isRouterAlive"></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'app',
	provide(){
		return {
			reload:this.reload
		}
	},
	data(){
		return {
			isRouterAlive:true
		}
	},
	methods:{
		reload(){
			this.isRouterAlive = false
			this.$nextTick(function(){
				this.isRouterAlive = true
			})
		}
	},
	
	components: {
	},
}

</script>

<style lang="scss">
.el-dialog__body{
	padding: 10px 20px;
}
.container .main .content-container .content-wrapper{
	padding:60px 60px 0 60px !important;
}
.rank_num .el-progress-bar__outer{
	background-color: #f2f9ff !important;
}
.checkName .el-input__icon{
	line-height: 30px;
}
.checkName .el-input__inner{
	height: 30px;
}
.el-table--enable-row-transition .el-table__body td{
	padding: 10px 0;
}
.el-table td, .el-table th{
	padding: 10px 0;
}

body {
	margin: 0px;
	padding: 0px;
	/*background: url(assets/bg1.jpg) center !important;
		background-size: cover;*/
	// background: #1F2D3D;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #fff;
	padding: 10px;
	//border:1px solid #dfe6ec;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
.ftBox {
    width: 100%;
    height: 30px;
    position: fixed;
    left: 0;
    bottom:0;
    box-sizing: border-box;
    // padding-left: 230px;
    .ft{
      width: 100%;
      height: 30px;
      background: rgba(0,0,0,.5);
      text-align: center;
      p {
          margin: 0;
          width: 100%;
          height: 100%;
          font-size: 13px;
          color: #fff;
          text-align: center;
          position: relative;
          line-height:30px;
      }
    }
}
</style>


// WEBPACK FOOTER //
// App.vue?ea5fec50